<script setup lang="ts">
defineProps<{
  label?: string;
}>();
</script>

<template>
  <Button
    class="af-button af-button-success"
    icon="pi pi-check"
    :label="label || $t('filters.apply')"
  />
</template>
